import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./AdjustStockForm";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelAddStock} from "../../../actions/InventoryApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence, validateGreaterThan} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";
import {stockableGroups} from "../../../lib/StockHelper";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "warehouseId");
  errors = validatePresence(errors, values, "productSku");
  errors = validateGreaterThan(errors, values, "quantity", 0);
  errors = validatePresence(errors, values, "reason");
  return errors.toJS();
}

class AddStockFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.addStock(values.toJS())
      .then((response) => {
        if (response.data.addStock.errors.length <= 0) {
          this.props.cancelAddStock();
        } else {
          let errors = createValidationErrors(response.data.addStock.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelAddStock();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />

    // TODO cleaner restriction for some users
    let validWarehouses = data.warehouses;
    if (this.props.accessibleWarehouseIds.size > 0) {
      validWarehouses = validWarehouses.filter(
        (warehouse) => this.props.accessibleWarehouseIds.contains(warehouse.id)
      )
    }

    let initialValues = fromJS({
      warehouseId: this.props.warehouseId
    })

    return (
      <Form
        initialValues={initialValues}
        warehouses={fromJS(validWarehouses)}
        products={fromJS(data.products)}
        productGroups={stockableGroups()}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const ADD_STOCK = gql`
  mutation addStock($data: StockChangeInput!) {
    addStock(input: $data) {
      errors { key message }
    }
  }
`;

const QUERY = gql`
  query adjustStockQuery {
    warehouses {
      id
      location
    }
    products: stockableProducts {
      sku
      title
      type
    }
  }
`;

const withProductQuery = compose(
  graphql(QUERY, {
    options: (props) => ({
      fetchPolicy: "network-only",
    })
  }),
  graphql(ADD_STOCK, {
    props: ({ mutate }) => ({
      addStock: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const AddStockFormContainerWithData = withProductQuery(AddStockFormContainer);

function mapStateToProps(state) {
  return {
    accessibleWarehouseIds: state.getIn(["auth", "accessibleWarehouseIds"]),
  }
}

export default connect(mapStateToProps, {cancelAddStock})(AddStockFormContainerWithData);